import JudgeGallery from './components/JudgeGallery.vue';
import ArtworkView from './components/ArtworkView.vue';

const routes = [
	{
        path: '/',
        name: 'index',
        component: JudgeGallery,
		props: true
    },
	{
        path: '/review/:artworkId',
        name: 'review',
        component: JudgeGallery,
		props: (route) => ({ artworkId: parseInt(route.params.artworkId) || 0 })
    },
]

export default routes;